// Texty ukazovateľa hmotnostných pásiem — slovenské dvojča locale/cs/weightScale.js.
import { NBSP } from '../../modules/money.js';

export default {
  free: 'Zadarmo',
  promoFrom: (price) => 'od ' + price,
  promoNote: (carrier, price, maxKg, until) =>
    'Akcia: ' + carrier + ' na výdajné miesto do ' + maxKg + NBSP + 'kg za ' + price + ', platí do ' + until.replace(/\.$/, '') + '.',
};
